import { BehaviorSubject } from 'rxjs';
export const getServerErrorsStore = () => {
    const getInitialState = () => ({
        formErrors: [],
        otherCustomErrors: []
    });
    const serverErrorsSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => serverErrorsSubject.subscribe(callback);
    const setFormErrors = (formErrors = []) => {
        serverErrorsSubject.next({
            ...serverErrorsSubject.getValue(),
            formErrors
        });
    };
    const setOtherCustomErrors = (otherCustomErrors = []) => {
        serverErrorsSubject.next({
            ...serverErrorsSubject.getValue(),
            otherCustomErrors
        });
    };
    const popOtherCustomError = (errorCode) => {
        const { otherCustomErrors } = serverErrorsSubject.getValue();
        const newOtherCustomErrors = otherCustomErrors.filter(error => error.Code !== errorCode);
        serverErrorsSubject.next({
            ...serverErrorsSubject.getValue(),
            otherCustomErrors: newOtherCustomErrors
        });
    };
    return {
        getInitialState,
        subscribe,
        setFormErrors,
        setOtherCustomErrors,
        popOtherCustomError
    };
};
